import AiHomeSkeleton from '../AiHome/AiHomeSkeleton';
import AnalyticsSkeleton from '../Analytics/AnalyticsSkeleton';
import CampaignsSkeleton from '../Campaigns/CampaignsSkeleton';
import CampaignDetailSkeleton from '../Campaigns/CampaignDetailSkeleton';
import ContactsSkeleton from '../Contacts/ContactsSkeleton';
import AccountsSkeleton from '../EmailAccoutDetail/AccountsSkeleton';
import SettingsSkeleton from '../Settings/SettingsSkeleton';
import { TasksSkeleton } from '../Tasks/TasksSkeletons';
import TeamSkeleton from '../Team/TeamSkeleton';
import UniboxSkeleton from '../Unibox/UniboxSkeleton';
import PendingApprovalsSkeleton from './PendingApprovalsSkeleton';

/*
 * Each page's own skeleton, by its nav.json view file, for the moments before
 * the page itself can render: while its code downloads and while the active
 * workspace resolves. The page's PageReveal shows the same skeleton once it
 * mounts, so the screen goes straight from skeleton to page, never blank.
 *
 * The skeleton modules import only styles and skeleton blocks, so keeping them
 * in the main bundle costs little.
 */
const VIEW_SKELETONS = {
  'ai-home': () => <AiHomeSkeleton />,
  analytics: () => <AnalyticsSkeleton />,
  'campaign-manager': () => <CampaignsSkeleton />,
  'campaign-detail': () => <CampaignDetailSkeleton />,
  'leads-module': () => <ContactsSkeleton />,
  'email-accounts': () => <AccountsSkeleton tab="email" />,
  'linkedin-accounts': () => <AccountsSkeleton tab="linkedin" />,
  profile: () => <SettingsSkeleton />,
  tasks: () => <TasksSkeleton />,
  teams: () => <TeamSkeleton />,
  unibox: () => <UniboxSkeleton />,
  'pending-approvals': () => <PendingApprovalsSkeleton />,
};

/** The skeleton for a view, or null for a page that has nothing to load (Workforce). */
export const viewSkeleton = view => VIEW_SKELETONS[view]?.() ?? null;
